const colors = {
	collectame: '#F27D18',
	'appcenter-customer': '#00121e',
	dokia: '#00AEDD',
	workflux: '#1969B2',
	'workflux-portal': '#157FE9'
}

export default colors
